import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'

import Navbar from '../components/navbar'
// import ServiceSidebars from '../components/service-sidebar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import Directorioshort from '../components/directorioshort'
import Tecnologiamini from '../components/tecnologiamini'
import sanitizeHtml from 'sanitize-html'
import Serviciosmini from '../components/serviciosmini'
import useCsrfToken from '../hooks/useCsrfToken'
import PackageSidebar from '../components/package-sidebar'
import { Helmet } from 'react-helmet-async'

export default function PaqueteDetalle() {
    const { csrfToken } = useCsrfToken();
    let [activeImage, setImage] = useState('');
    let params = useParams();
    let slug = params.slug
    const [listing, setListing] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    const stripTagsFromHtml = (html) => {
        const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
        return sanitizeHtml(html, {
            allowedTags: allowedTags
        });
    };

    const stripAllTagsFromHtml = (html) => {
        return sanitizeHtml(html, {
            allowedTags: []
        });
    };

    const handleImageChange = (index) => {
        const images = document.querySelectorAll('.gallerimage');
        images.forEach((img, imgIndex) => {
            img.classList.remove('fade-in');
            img.classList.add('fade-out');
            setTimeout(() => {
                setImage(API_URL + listing.gallerylarge[index].url_large)
                img.classList.add('fade-in');
                img.classList.remove('fade-out');
            }, 500);
        });
    }

    useEffect(() => {
        // if (csrfToken === null) return;
        const transformData = (data) => {
            const formatPrice = (price) => {
                return price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
            };
            const preloadImages = (images) => {
                images.forEach(image => {
                    const img = new Image();
                    img.src = `${API_URL}${image.url_large}`;
                });
            };

            if (data.gallery?.galleryimages) {
                preloadImages(data.gallery.galleryimages);
            }
            return {
                id: data.id,
                decrid: data.encrid,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Paquetes',
                name: data.title,
                slug: data.slug,
                intro: data.intro !== '' ? stripTagsFromHtml(data.intro) : '',
                desc: data.description !== '' ? stripTagsFromHtml(data.description) : '',
                terms: data.terms !== '' ? `<strong>Términos</strong>: ${stripTagsFromHtml(data.terms)}` : '',
                tags: data.tags,
                gallery: data.gallery?.gallerythumbs,
                gallerylarge: data.gallery?.galleryimages,
                brochure_url: data.brochure_url,
                cta_url: data.cta_url,
                phone_1: data.phone_1,
                title: data.title,
                listing_type: data.listing_type,
                embed: data.embed,
                cta_icon: data.cta_icon,
                branches: data.branches,
                price: formatPrice(data.price),
                price_discount: formatPrice(data.price_discount),
                price_members: formatPrice(data.price_members),
                package_type: data.package_type,
                encrid: data.encrid,
                hasdiscount: data.price_discount > 0 ? true : false,
                hasmembersprice: data.price_members > 0 ? true : false
            };
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listing/${slug}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    setListing(transformData(data))
                    setImage(API_URL + data.gallery?.galleryimages[0].url_large);
                    // console.log('Data:', data);

                })
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [API_URL, slug, csrfToken]);

    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>{`${listing.name} | Paquetes y promociones`}</title>
                <meta name="description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta property="og:title" content={`${listing.name} | Paquetes y promociones`} />
                <meta property="og:description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta property="og:image" content={`${listing.image}`} />
                <meta property="og:url" content={`${basedomain}/${listing.slug}`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${listing.name} | Paquetes y promociones`} />
                <meta name="twitter:description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta name="twitter:image" content={`${listing.image}`} />
                <meta itemprop="name" content={`${listing.name} | Paquetes y promociones`} />
                <meta itemprop="description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta itemprop="image" content={`${listing.image}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${listing.image})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark mt-4">{listing.name}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page"><Link to="/paquetes">Paquetes</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{listing.name}</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            {listing.name != null ? (
                                <div className="card border-0 shadow rounded overflow-hidden">

                                    <div className="card-body">
                                        {listing.embed && listing.embed.includes('<') && (
                                            <div className="text-center mb-2 p-3 pt-1 position-relative" dangerouslySetInnerHTML={{ __html: listing.embed }} />
                                        )}
                                        {(!listing.embed || !listing.embed.includes('<')) && (
                                            <>
                                                <img src={activeImage ? activeImage : listing.image} className="img-fluid galMainImage w-100 gallerimage gallerimage-square" alt="" />
                                                <div className="row mt-4">
                                                    {listing.gallery && listing.gallery.map((item, index) => (
                                                        <div key={index} className="col-4 col-md-2">
                                                            <Link onClick={() => handleImageChange(index)}>
                                                                <img src={API_URL + item.url_thumbnail} alt="Galería" className='img-fluid' />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                        <blockquote className="text-center mx-auto blockquote">
                                            <i className="mdi mdi-format-quote-open mdi-48px text-muted opacity-2 d-block"></i>
                                            <div dangerouslySetInnerHTML={{ __html: listing.intro }} />
                                        </blockquote>

                                        <br />
                                        <h5 className='fw-bold my-3'>Disponible en:<br />
                                            {listing.branches && listing.branches.map((item, index) => (
                                                <span key={index} to="#" className="badge badge-link me-1 bg-lightgray">
                                                    {item.title}
                                                </span>
                                            ))}
                                        </h5>
                                        <div className="text-muted" dangerouslySetInnerHTML={{ __html: listing.desc }} />
                                        {listing.tags && listing.tags.map((item, index) => (
                                            <Link key={index} to="#" className="badge badge-link me-1" style={{ backgroundColor: item.color }}>
                                                {item.title}
                                            </Link>
                                        ))}
                                        {listing.embed && listing.embed.includes('<') && (
                                            <>
                                                <hr className='pb-4 mt-5' />
                                                <img src={activeImage ? activeImage : listing.image} className="img-fluid galMainImage w-100 gallerimage gallerimage-square" alt="" />
                                                <div className="row mt-4">
                                                    {listing.gallery && listing.gallery.map((item, index) => (
                                                        <div key={index} className="col-4 col-md-2">
                                                            <Link onClick={() => handleImageChange(index)}>
                                                                <img src={API_URL + item.url_thumbnail} alt="Galería" className='img-fluid' />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                        <div className="text-muted mt-5 small" dangerouslySetInnerHTML={{ __html: listing.terms }} />
                                    </div>
                                </div>
                            ) : (
                                <div className="col-12 text-center">
                                    Cargando...
                                </div>
                            )}
                        </div>

                        <div className="col-lg-4 col-md-5 col-12 mt-4 pt-2 mt-md-0 pt-md-0">
                            <PackageSidebar brochure_url={listing.brochure_url} cta_url={listing.cta_url} phone_1={listing.phone_1} title={listing.title} listing_type={listing.listing_type} cta_icon={listing.cta_icon} listingid={listing.encrid} price={listing.price} price_discount={listing.price_discount} price_members={listing.price_members} package_type={listing.package_type} hasmembersprice={listing.hasmembersprice} hasdiscount={listing.hasdiscount} />
                        </div>
                    </div>
                </div>
            </section>
            <Serviciosmini listingid={listing.encrid} bgmode='bg-inverted' />
            <Tecnologiamini listingid={listing.decrid} />
            <Directorioshort listingid={listing.encrid} bgmode='bg-inverted' />
            <Footer />
            <ScrollToTop />
        </>
    )
}
